import { create, clickable, collection, isPresent, text, visitable } from 'ember-cli-page-object';
export default create({
  visit: visitable('/public/registries/:registry/boxes/:box/versions/:version'),
  title: text('[data-test-title]'),
  subtitle: text('[data-test-subtitle]'),
  shortDescription: text('[data-test-short-description]'),
  providers: collection('[data-test-providers] > li', {
    name: text('h3'),
    isEmpty: isPresent('div + em'),
    architectures: collection('> ol > li', {
      type: text('span > span'),
      url: text('[data-test-description="external"]'),
      hasUrl: isPresent('[data-test-description="external"]'),
      size: text('[data-test-description="hosted"]'),
      hasSize: isPresent('[data-test-description="hosted"]'),
      download: clickable('[data-test-boxfile-download]')
    })
  })
});